export const UPDATE_ACCOUNT_INFO = "USER/UPDATE_ACCOUNT_INFO";
export const UPDATE_ACCOUNT_INFO_SUCCESS = "USER/UPDATE_ACCOUNT_INFO_SUCCESS";
export const UPDATE_ACCOUNT_INFO_FAILURE = "USER/UPDATE_ACCOUNT_INFO_FAILURE";
